<template>
    <ion-content class="ion-padding">
        <ion-grid>
            <ion-accordion-group :multiple="false">
                <ion-row>
                    <ion-col
                        size="12"
                        size-md="6"
                        v-for="(setup, index) in chargerSetup"
                        :key="index"
                    >
                        <ion-card>
                            <ion-accordion :value="index.toString()">
                                <ion-item slot="header">
                                    <ion-label>
                                        <b>{{ setup.title }}</b>
                                    </ion-label>
                                </ion-item>
                                <div slot="content">
                                    <ion-list>
                                        <ion-list>
                                            <ion-item
                                            v-for="(item, i) in setup.items.filter(item => item.roleAccess.includes(userRole))"
                                            :key="i"
                                            button
                                            @click="openSetup(item)"
                                            >
                                                <ion-label>{{ item.label }}</ion-label>
                                            </ion-item>
                                        </ion-list>
                                    </ion-list>
                                </div>
                            </ion-accordion>
                        </ion-card>
                    </ion-col>
                </ion-row>
            </ion-accordion-group>
        </ion-grid>
    </ion-content>
</template>

<script>
import { defineComponent } from "vue";
import { IonContent, IonGrid, IonRow, IonCol, IonLabel, modalController, IonCard, IonAccordionGroup, IonAccordion, IonList, IonItem } from "@ionic/vue";
import data from "../../../public/assets/data/data.json";
import chargerSetupModel from "./ChargerSetupModel.vue";

export default defineComponent({
    name: "chargerSetup",
    components: {
        IonContent, 
        IonGrid, 
        IonRow, 
        IonCol, 
        IonLabel,
        IonCard,
        IonAccordionGroup,
        IonAccordion,
        IonList,
        IonItem, 
        modalController
    },
    data() {
        return {
        chargerSetup: data.chargerSetup,
        userRole: Number(localStorage.getItem("user.roleId"))
        };
    },

    methods: {
        async openSetup(item) {
            const modal = await modalController.create({
                component: chargerSetupModel,
                componentProps: {
                    title: item.label,
                    url: item.url,
                },
                cssClass: "charger-setup",
            });

            await modal.present();

            const { data } = await modal.onDidDismiss();

            if (data) {
                console.log(data);
            }
        },
        getAccess(roleList) {
            let userRole = localStorage.getItem("user.roleId");
            // console.log(roleList)
            // console.log(userRole)
            let role = "NotFound";
            if (roleList.includes(userRole)) {
                role = "found"
            }
            // console.log(role); 
            return role == "found" ? true : false;
        }
    },
});
</script>

<style scoped>
.my-custom-class {
  background-color: #222;
  width: 50% !important;
}

ion-modal {
 --width: 80% !important; 
 --hight: 80% !important;
}

.my-custom-class {
 --width: 50% !important; 
 --hight: 100% !important;

}
ion-card {
  border-radius: 18px;
  box-shadow: 0 3px 10px rgba(0,0,0,.15);
}

ion-item {
  --padding-start: 20px;
}

ion-label {
  font-size: 18px;
}
</style>